import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';
import type { ScheduledRide, ScheduledRideInput } from '@/models/scheduledRide';

export const createScheduledRide = async (data: ScheduledRideInput, disallowVendorScheduledRide = false): Promise<ScheduledRide> => {
  const response = await mutationExecute({
    variables: {
      data,
      disallowVendorScheduledRide,
    },
    mutation: graphql(`
      mutation CreateScheduledRide($data: ScheduledRideInputType!, $disallowVendorScheduledRide: Boolean) {
        createScheduledRide(data: $data, disallowVendorScheduledRide: $disallowVendorScheduledRide) {
          id
        }
      }
    `),
  });

  return response.data?.createScheduledRide!;
};
